import { createReducer, on } from '@ngrx/store';

import {
  fetchPlants,
  fetchPlantsSuccess,
  fetchPlantsFailure,
  updatePlantStatus,
  dateChanged,
  getLatestPlantNetworkStatus,
  getLatestPlantNetworkStatusSuccess,
  getLatestPlantNetworkStatusFailure,
  getLatestPlantsNetworkStatus,
  getLatestPlantsNetworkStatusSuccess,
  getLatestPlantsNetworkStatusFailure,
} from './plant-network-status.actions';
import { PlantsNetworkState, PlantNetworkStatus } from './plant-network-status.models';

export const initialState: PlantsNetworkState = {
  plants: new Map<string, PlantNetworkStatus>(),
  currentDate: new Date().toISOString().slice(0, 10),
  isLoading: false,
  error: null,
};

export const plantNetworkStatusReducer = createReducer(
  initialState,
  on(fetchPlants, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(fetchPlantsSuccess, (state, { plants }) => ({
    ...state,
    plants: new Map(plants?.map((plant) => [plant.PlantCode, { ...plant }]) ?? []),
    isLoading: false,
    error: null,
  })),
  on(fetchPlantsFailure, (state, { payload }) => ({
    ...state,
    isLoading: false,
    error: payload,
  })),
  on(getLatestPlantNetworkStatus, (state, { plantCode }) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(getLatestPlantNetworkStatusSuccess, (state, { plantCode, plant }) => ({
    ...state,
    plants: new Map(state.plants).set(plantCode, { ...plant }),
    isLoading: false,
    error: null,
  })),
  on(getLatestPlantNetworkStatusFailure, (state, { plantCode, error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(getLatestPlantsNetworkStatus, (state, { plantCodes }) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(getLatestPlantsNetworkStatusSuccess, (state, { plantCodes, plants }) => ({
    ...state,
    plants: new Map([...state.plants, ...(plants?.map((p) => [p.PlantCode, p] as [string, PlantNetworkStatus]) ?? [])]),
    isLoading: false,
    error: null,
  })),
  on(getLatestPlantsNetworkStatusFailure, (state, { plantCodes, error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(updatePlantStatus, (state, { payload }) => {
    const { PlantCode, IsOnline } = payload;
    const plants = new Map(state.plants);
    const plant = { ...plants.get(PlantCode), IsOnline };

    if (plant) {
      plants.set(PlantCode, plant);
    }
    // console.log('Reducer - updatePlantStatus:', state.plants);

    return {
      ...state,
      plants,
    };
  }),
  on(dateChanged, (state, { payload }) => ({
    ...state,
    currentDate: payload,
  })),
);
